import React from "react";
import { ProgressBar as RBProgressBar } from "react-bootstrap";

const ProgressBar = ({
  width,
  progressText,
  test = false,
  createdAt,
}) => {
  const getStartingDate = () =>
    new Date(createdAt).toLocaleDateString("en-US");

  return (
    <div className="w-100">
      
      {/* Top Row */}
      <div className="d-flex justify-content-between align-items-center mb-1">
        <small className="fw-semibold text-secondary">
          {progressText || "Progress"}
        </small>
        <small className="fw-bold text-dark">
          {width}
        </small>
      </div>

      {/* Progress Bar */}
      <RBProgressBar
        now={parseInt(width)}
        className="w-100 custom-progress rounded-pill"
      />

      {/* Bottom Info */}
      {!test && (
        <div className="mt-1">
          <small className="text-dark fw-semibold">
            {getStartingDate()}
          </small>
          <div>
            <small className="text-muted">
              Starting Date
            </small>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;